module.exports = __webpack_public_path__ + "be6c9c361a22d0fc55112003287c58d8.svg";